const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogTurno(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogTurno`, params);
    },
    $obterRelatorioLogCSVTurno(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogTurnoCsv`, params);
    },
    $obterRelatorioLogPDFTurno(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogTurnoPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
